





































































































































import Vue from 'vue';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import ClaimTable from './claim-table.component.vue';
import { evaultCategoryKey } from '@/constants';
import { api, CLAIM_API_SUB_URLS, VAULT_API_SUB_URLS } from '@/api';
import { EventBus } from '@/event-bus';
import { ExtendMixins } from '@/services';

interface Data {
  confirmBeforeClose: boolean;
  changeMade: boolean;
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  document: any;
  file: any;
  selectedClaim: any;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'MatchToTransaction',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      confirmBeforeClose: true,
      changeMade: false,
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      document: this.params.document,
      file: this.params.file,
      selectedClaim: {},
    };
  },
  beforeMount() {
    if (this.file) {
      const reader = new window.FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        (this.$refs.dynamicImage as any).src = reader.result;
      };
    }
  },
  computed: {
    memberId(): string {
      return this.$store.getters.user.memberId;
    },
    isPDF(): boolean {
      return this.document.fileName && this.document.fileName.endsWith('.pdf');
    },
    isTIFF(): boolean {
      const filename = this.document.fileName;
      return (
        filename && (filename.endsWith('.tiff') || filename.endsWith('.tif'))
      );
    },
    category(): string {
      return this.$options.filters.t(evaultCategoryKey[this.document.category]);
    },
    disableSubmitButton(): boolean {
      return (
        this.selectedClaim.id === null ||
        typeof this.selectedClaim.id === 'undefined'
      );
    },
  },
  methods: {
    setSelectedClaim(claim): void {
      this.selectedClaim = claim;
    },
    submit(): void {
      this.isLoading = true;
      const PAYLOAD = {
        memberAccountId: null,
        startDate: this.selectedClaim.startDate,
        endDate: this.selectedClaim.endDate,
        serviceType: null,
        providerId: null,
        patientName: this.selectedClaim.patientName,
        providerTaxID: null,
        providerName: this.selectedClaim.providerName,
        amount: this.document.amount,
        vaultData: [
          {
            vaultId: `${this.document.vaultId}`,
            fileName: this.document.fileName,
            fileNickname: this.document.fileNickname,
            category: this.document.category,
            uploadDate: this.document.uploadDate,
            imageUUID: null,
          },
        ],
        isSubmitted: true,
        isMatched: true,
        matchId: this.selectedClaim.id,
        onlineClaimId: null,
        noteToSelf: this.selectedClaim.noteToSelf,
        isSubstantiation:
          this.selectedClaim.transactionStatus === 'Needs Receipt'
            ? true
            : null,
        isClaim: false,
      };

      if (this.selectedClaim.transactionStatus === 'Needs Receipt') {
        // UC-REST-031 - Update Card Substantiation
        api
          .put(`${CLAIM_API_SUB_URLS.claims}/hsa/${this.selectedClaim.id}/substantiations`, this.constructUnsubstantiatedClaimRequest())
          .then(() => {
            this.refreshEvaultData();
          })
          .catch(() => {
            this.confirmBeforeClose = false;
            this.showErrorMessage = true;
            this.isLoading = false;
          });
      } else {
        // UC-REST-028 - Update Vault Data
        api
          .patch(`${VAULT_API_SUB_URLS.vaultData}/${this.document.vaultId}`, this.constructStandardClaimRequest())
          .then(() => {
            this.refreshEvaultData();
          })
          .catch(() => {
            this.confirmBeforeClose = false;
            this.showErrorMessage = true;
            this.isLoading = false;
          });
      }
    },
    constructUnsubstantiatedClaimRequest(): any {
      return {
        memberId: this.memberId,
        startDate: this.selectedClaim.startDate,
        endDate: this.selectedClaim.endDate,
        providerName: this.selectedClaim.providerName,
        patientName: this.selectedClaim.patientName,
        amount: this.document.amount,
        noteToSelf: this.selectedClaim.noteToSelf ? this.selectedClaim.noteToSelf[0] : null,
        images: [{
          vaultId: `${this.document.vaultId}`,
          imageId: this.document.vaultId ? null : this.document.uuid,
          imageFileName: this.document.fileName,
          imageFileNickname: this.document.fileNickname,
          uploadDate: this.document.uploadDate,
        }],
      };
    },
    constructStandardClaimRequest(): any {
      return {
        memberId: this.memberId,
        vaultId: `${this.document.vaultId}`,
        fileName: this.document.fileName,
        fileNickname: this.document.fileNickname,
        category: this.document.category,
        fromDate: this.selectedClaim.startDate,
        toDate: this.selectedClaim.endDate,
        amount: this.document.amount,
        patientName: this.selectedClaim.patientName,
        providerName: this.selectedClaim.providerName,
        noteToSelf: this.selectedClaim.noteToSelf ? this.selectedClaim.noteToSelf[0] : null,
        isSubmitted: true,
        isMatched: true,
        matchId: this.selectedClaim.id,
        onlineClaimId: null,
        iCaseId: null,
        iCaseLineId: null,
      };
    },
    refreshEvaultData(): void {
      this.$store
        .dispatch('getVaultData')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
          EventBus.$emit('refreshEvault');
        })
        .catch(() => {
          this.triggerRefreshError({
            message: [
              'match-to-transaction_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
          this.confirmBeforeClose = false;
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    ClaimTable,
  },
});
